import React, { Component } from 'react'
import './styles.css'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import moment from 'moment'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { NOME_EMPRESA } from '../../config'
import Alert from '../../components/alert'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDollarSign } from '@fortawesome/free-solid-svg-icons'
import Util from '../../classes/util'
import ListaProdutos from '../../components/listaProdutos'
import Footer from '../../components/footer'

const estadoInicial = {
    programacao: [],
    produtosEscolhidos: [],
    produtos: [],
    produtosVouchers: [],
    valorTotal: 0,
    ticket: {},
    vouchers: [],

    empresa: null,
    unidade: null,
    produto: null,


    loading: false,
    redirect: false,

    chave: '',
    quantidade: 0,
    vouchersPendentes: 0,
    vouchersInutilizados: 0,
    saldoDisponivel: 0,
    saldoAtualEmpresa: NaN,
    saldoAtualVouchers: NaN,
    voucherID: 0,
}

class Cobranca extends Component {

    state = {
        ...estadoInicial
    }
    componentDidMount = async () => {
        const { id } = this.props.match?.params;

        this.setState({ chave: id });
        await this.loadSaldo(id);
        await this.loadVouchers();
    }


    loadSaldo = async (id) => {
        await apiEmployee.get(`/vouchers/cobrarvoucher/${id}`)
            .then(res => {
                this.setState({
                    programacao: res.data.programacao[0],
                    quantidade: res.data.programacao[0].quantidade,
                    vouchersInutilizados: res.data?.soma_lancamentos || 0,
                })
            })
        const produtos = await apiEmployee.get(`produtoscreditos/unidade/${localStorage.getItem('empresaID')}/${this.state.programacao.chave_unidade}`).then(res => res.data).catch(err => [])
        this.setState({ vouchersPendentes: this.state.quantidade - this.state.vouchersInutilizados })
        this.setState({ saldoDisponivel: this.state.vouchersPendentes * this.state.programacao.preco })
        this.setState({ produtos })
        this.loadSaldoEmpresa(this.state.programacao.chave_pessoa)

    }

    loadSaldoEmpresa = async (id) => {
        const tickets = await apiEmployee.get(`tickets/ticketsCreditosEmpresas/${id}`).then(res => res.data).catch(err => []);

        let saldoAtualEmpresa = 0;
        if (tickets[0]) {
            tickets.filter((ticket) => ticket.status == 2).forEach((ticket) => {
                saldoAtualEmpresa += ticket.saldo;
            })
        } else {
            saldoAtualEmpresa = NaN;
        }
        this.setState({ saldoAtualEmpresa, ticket: tickets.find((ticket) => ticket.status == 2) })

    }

    loadVouchers = async () => {
        const vouchers = await apiEmployee.get(`/vouchers/getvouchers/${localStorage.getItem('empresaID')}`).then(res => res.data).catch(err => []);
        this.setState({
            vouchers: vouchers,
        });

        let saldoAtualVouchers = 0;
        if (vouchers[0]) {
            vouchers.filter((ticket) => ticket.cancelado == 0).forEach((ticket) => {
                saldoAtualVouchers += ticket.saldo;
            })
        } else {
            saldoAtualVouchers = NaN;
        }
        this.setState({ saldoAtualVouchers })
    }

    saveCobrancaLancamento = async () => {
        const programacaoPayload = [];
        const lancamentosPayload = [];
        const creditosItensPayload = [];
        this.state.produtosEscolhidos.forEach((produto) => {
            lancamentosPayload.push({
                chave_ticket: this.state.ticket.chave,
                chave_usuario: this.props.id,
                chave_unidade: this.state.programacao.chave_unidade,
                chave_pessoa: localStorage.getItem('empresaID'),
                valor: (produto.preco * produto.quantidade).toFixed(2),
                chave_produto: produto.chave,
                tipo: 'DESCONTO'
            });
        });

        const programacao = this.state.programacao;
        programacaoPayload.push({
            chave: programacao.chave,
            chave_pessoa: programacao.chave_pessoa,
            data: moment(programacao.data).format('YYYY-MM-DD'),
            chave_unidade: programacao.chave_unidade,
            chave_produto: programacao.chave_produto,
            quantidade: programacao.quantidade,
            conferida: moment().format('YYYY-MM-DD'),
        })

        const ticket = this.state.ticket;
        const creditoPayload = {
            chave: ticket.chave,
            empresa: ticket.empresa,
            chave_pessoa: ticket.chave_pessoa,
            valor: ticket.valor,
            status: 2,
            chave_unidade: ticket.chave_unidade,
            meio_pagamento: ticket.meio_pagamento,
            data: moment(ticket)?.format('YYYY-MM-DD'),
            saldo: (ticket.saldo - this.state.valorTotal.toFixed(2))
        }

        const saved = await apiEmployee.post(`vouchers/salvarcobranca`, {
            programacaoPayload,
            lancamentosPayload,
            creditosItensPayload,
            creditoPayload
        }).then((res) => res.data)
            .catch(err => null);

        if (saved) {
            this.setState({
                redirect: true,
            })
        }
    }

    saveCobrancaVoucher = async (id) => {
        const voucher = await apiEmployee.get(`/vouchers/detalhavoucher/${id}`);
        const saldoVoucher = voucher.data.saldo;
        let saldoVoucherResto = 0;
        let saldoDisponivelResto = 0;

        if (saldoVoucher > this.state.saldoDisponivel) {
            saldoVoucherResto = saldoVoucher - this.state.saldoDisponivel;
            this.setState({ saldoDisponivel: saldoDisponivelResto, redirect: true })
        } else {
            saldoDisponivelResto = this.state.saldoDisponivel - saldoVoucher;
            this.setState({ saldoDisponivel: saldoDisponivelResto })
        }

        const vouchersPayload = {
            chave: voucher.data.chave,
            data: moment(voucher.data.data).format('YYYY-MM-DD HH:mm:ss'),
            chave_pessoa: voucher.data.chave_pessoa,
            chave_usuario: voucher.data.chave_usuario,
            chave_unidade: voucher.data.chave_unidade,
            chave_produto: voucher.data.chave_produto,
            valor: voucher.data.valor,
            saldo: saldoVoucherResto,
            tipo: voucher.data.tipo,
            data_utilizacao: moment().format('YYYY-MM-DD HH:mm:ss'),
            cancelado: 0,
        };

        const programacaoPayload =  {
            data: moment(this.state.programacao.data).format('YYYY-MM-DD HH:mm:ss'),
            chave: this.state.programacao.chave
        }
        const saved = await apiEmployee.post(`vouchers/salvarcobrancavoucher`, {
            vouchersPayload,
            programacaoPayload
        }).then((res) => res.data)
            .catch(err => null);

        if (saved) {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className='custom-ui text-center'>
                            <h1>{NOME_EMPRESA}</h1>
                            <p>Voucher cobrado com sucesso!</p>
                            <button
                                style={{ marginRight: 5 }}
                                className="btn btn-success w-50"
                                onClick={
                                    async () => {
                                        onClose()
                                    }
                                }
                            >
                                Ok
                            </button>
                        </div>
                    )
                }
            })
        }

        if (saved && saldoDisponivelResto === 0) {
            this.setState({
                redirect: true,
            })
        }
    }

    render() {

        return (
            <div className='page'>
                <div
                    style={{
                        position: "absolute",
                        left: "-900000px",
                        top: 0,
                    }}
                >
                </div>
                {this.state.redirect &&
                    <Redirect to={'/programacao'} />
                }
                {!this.state.loading &&
                    <div>
                        <section>
                            {this.state.redirect &&
                                <Redirect
                                    to={'/programacao'}
                                />
                            }
                            <Header voltar />

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="page-breadcrumb">
                                        <h2 id='titulo'>Cobrança de vouchers</h2>
                                        <div className="saldo_criar_voucher">
                                            <span>{this.state.saldoDisponivel === 0 ? "Saldo indisponível" : `Saldo atual: R$${Util.formatarDinheiro(this.state.saldoDisponivel)}`}</span>
                                        </div>
                                        <div className="saldo_criar_voucher">
                                            <span>{this.state.saldoAtualEmpresa < this.state.saldoDisponivel ? "Saldo da empresa insuficiente" : `Saldo atual da empresa: R$${Util.formatarDinheiro(this.state.saldoAtualEmpresa)}`}</span>
                                        </div>
                                        {this.state.saldoAtualEmpresa >= this.state.saldoDisponivel ?
                                            <div>
                                                <ListaProdutos
                                                    onSubmit={(produtos) => { let valor = 0; produtos.map((p) => { valor += p.preco * p.quantidade }); this.setState({ produtosEscolhidos: produtos, valorTotal: valor }) }}
                                                    setProdutosEscolhidos={(produtos) => this.setState({ produtosEscolhidos: produtos })}
                                                    setValorTotal={(valor) => this.setState({ valorTotal: valor })}
                                                    produtosEscolhidos={this.state.produtosEscolhidos}
                                                    valorTotal={this.state.valorTotal}
                                                    maxValue={this.state.saldoDisponivel}
                                                    produtos={this.state.produtos}
                                                />
                                                <div className='form_produtos_lista_item bold'>
                                                    <div>Total</div>
                                                    <div>R$ {Util.formatarDinheiro(this.state.valorTotal)}</div>
                                                </div>
                                                <div className='col-12 contvtt display_row_spaced'>
                                                    <button type='button' className="button_salvar" onClick={() => this.saveCobrancaLancamento()}>Salvar</button>
                                                </div>
                                            </div>
                                            :
                                            <div>
                                                <div className="saldo_criar_voucher">
                                                    <span>{this.state.saldoAtualVouchers === 0 ? "Saldo de vouchers indisponível" : `Saldo atual de vouchers: R$${Util.formatarDinheiro(this.state.saldoAtualVouchers)}`}</span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: 10 }}>
                                                    <table className='table-programacao'>
                                                        <thead>
                                                            <tr>
                                                                <th className='column-programacao'>Empresa</th>
                                                                <th className='column-programacao'>Unidade</th>
                                                                <th className='column-programacao'>Funcionário</th>
                                                                <th className='column-programacao'>Valor</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.vouchers.filter((ticket) => ticket.cancelado == 0).map((voucher, index) => {
                                                                return (
                                                                    <tr>
                                                                        <td>{voucher.empresaNome}</td>
                                                                        <td>{voucher.unidadeNome}</td>
                                                                        <td>{voucher.pessoaNome}</td>
                                                                        <td>R${Util.formatarDinheiro(voucher.saldo)}</td>
                                                                        <td>
                                                                            <FontAwesomeIcon
                                                                                className={`prog_button ${(voucher.saldo > 0) ? '' : 'prog_disabled'}`}
                                                                                style={{ marginLeft: '10%' }}
                                                                                title={(voucher.saldo > 0) ? 'Debitar' : `Cobrança já feita.`}
                                                                                icon={faDollarSign}
                                                                                color={"#DE3338"}
                                                                                size={'1x'}
                                                                                onClick={() => this.saveCobrancaVoucher(voucher.chave)} />
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>}
                                    </div>
                                </div>
                            </div>

                        </section>

                    </div>
                }
                <Footer />
            </div>
        )

    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        id: user.id,
        empresa: user.empresa,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(Cobranca)